var React = require('react');

function IconEnjoypoints (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"4"},[React.createElement("path",{"d":"m30 61.5h68v42h-68z","key":0}),React.createElement("path",{"d":"m24 45.5h80v16h-80z","key":1}),React.createElement("path",{"d":"m64 103.5v-58","key":2}),React.createElement("path",{"d":"m74 25.5a10 10 0 0 1 10 10 10 10 0 0 1 -10 10h-10a0 0 0 0 1 0 0v-10a10 10 0 0 1 10-10z","key":3}),React.createElement("path",{"d":"m56 29.5a8 8 0 0 1 8 8v8a0 0 0 0 1 0 0h-8a8 8 0 0 1 -8-8 8 8 0 0 1 8-8z","key":4})]));
}

IconEnjoypoints.defaultProps = {"viewBox":"0 0 128 128"};

module.exports = IconEnjoypoints;

IconEnjoypoints.default = IconEnjoypoints;
